<template>
  <!-- <div id="pingfen" class="pingfen"> -->
  <van-popup v-model:show="show" :style="{ padding: '20px 10px 100px' }" :close-on-click-overlay="false">
    <p class="popup-tle">我要评分</p>
    <img src="@/assets/img/icon32.png" class="popup__close pointer" @click="handleClose">
    <RateSlider @updateVal="handleUpdateVal" :key="rateKey"></RateSlider>

    <p class="popup-sub" :class="{'ban': isBan}" @click="handleSub">提交</p>
  </van-popup>
  <!-- </div> -->

</template>
<script setup>
import { ref, defineProps, defineEmits, watchEffect, computed } from "vue";
import RateSlider from "@/components/RateSlider.vue";
import { showSuccessToast } from 'vant';
import { useRouter } from "vue-router"
import { score } from "@/api/culture.js";
const router = useRouter();
const { currentRoute } = router;

// console.log(currentRoute.value.meta)

const rateKey = ref(0)

const props = defineProps({
  rateDialog: {
    type: Boolean,
    default: false
  },
  rateid: {
    type: Number,
    default: 0
  },
  rateCateId: {
    type: Number,
    default: 0
  }
});
//按钮状态
const ban = ref(true);

const isBan = computed(() => {
  return ban.value
})
//滑块数值

const rateVal = ref(0);
const handleUpdateVal = (val) => {
  rateVal.value = val
  if (val == 0) {
    ban.value = true
  } else {
    ban.value = false
  }
}

const show = ref(props.rateDialog);



//关闭弹窗
const emits = defineEmits(["update:rateDialog"])
const handleClose = () => {
  rateKey.value++
  emits("update:rateDialog", false)
  show.value = false
}
//滑块
// const value = ref(0);

//提交
/*
刚打开弹窗是，isBan为true。当isBan为true时，禁止点击
*/
const handleSub = async () => {
  if (isBan.value) {
    return;
  } else {
    // show.value = false;
    emits("update:rateDialog", false)
    // 执行提交
    const data = {
      score: rateVal.value,
      id: props.rateid,
      cate_id: props.rateCateId,
    }
    const backData = await score(data)
    rateKey.value++
    if (backData.errcode === 1) {
      showSuccessToast({
        // teleport: '.pingfen',
        className: currentRoute.value.meta.fixed ? 'portraitRotate90' : '',
        message: "评分成功"
      })
    }
  }
}

watchEffect(() => {
  if (props.rateDialog) {
    const flag = props.rateDialog
    show.value = flag
  } else {
    show.value = false
  }
})
</script>
<style scoped>
.popup-tle {
    text-align: center;
    margin-bottom: 52px;
    font-size: 16px;
    color: #333333;
}
.popup__close {
    position: absolute;
    width: 20px;
    top: 20px;
    right: 20px;
    z-index: 99;
}
.popup-sub {
    font-size: 14px;
    background-color: #3F7C93;
    padding: 6px 15px;
    border-radius: 16px;
    position: absolute;
    bottom: 20px;
    right: 10px;
    color: #ffffff;
}
.ban {
    background-color: #989999;
}
</style>